// extracted by mini-css-extract-plugin
export default {"buttons":"buttons__3PP0Y","box":"box__Eh2XT"};